import './Appointment.scss';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadAppointment } from 'actions/appointments';
import AppointmentActions from 'organisms/Appointments/AppointmentActions';
import AppointmentDrawerLoader from 'organisms/Loaders/AppointmentDrawerLoader';
import {
  appointmentFailure,
  appointmentRequest,
  appointmentSuccess,
} from 'store/reducers/appointment';

import GroomerInfo from './GroomerInfo';
import Notes from './Notes';
import PetInfo from './PetInfo';
import SummaryInfo from './SummaryInfo';

export default function AppointmentDrawer() {
  const dispatch = useDispatch();
  const { uuid: appointmentUuid } = useSelector((state) => state.ui.drawer);
  const appointment = useSelector((state) => state.appointment);

  useEffect(() => {
    dispatch(
      loadAppointment({
        apuid: appointmentUuid,
        actions: [appointmentRequest, appointmentSuccess, appointmentFailure],
      })
    );
  }, []);

  if (appointment?.isLoading)
    return (
      <div className="appointment-drawer">
        <AppointmentDrawerLoader />
      </div>
    );

  return (
    <div className="appointment-drawer flex-column align-end">
      <div className="w-100">
        <div className="flex-row justify-between mb-25">
          <h2 className="f26">Appointment details</h2>
          <AppointmentActions
            appointment={appointment}
            type="list"
            dropdownOnly
          />
        </div>
        <GroomerInfo />
        <PetInfo />
        <SummaryInfo />
        <Notes />
        <AppointmentActions appointment={appointment} type="drawer" />
      </div>
    </div>
  );
}
